<div class="tw-flex tw-flex-row tb:tw-flex-col tw-gap-3 tw-w-full tb:tw-gap-6 tw-h-full">
  <!--  Mobile filter bottom sheet overlay (only renders when showMobileFilter is true) -->
  @if (showMobileFilter()) {
    <!-- Backdrop -->
    <div
      class="tw-hidden tb:tw-block tw-fixed tw-inset-0 tw-z-40"
      (click)="toggleMobileFilter()"
    ></div>

    <!-- Bottom sheet menu -->
    <div
      appGlossScroll
      #mobileFilterPanel
      id="plans-mobile-filter-panel"
      role="dialog"
      aria-label="Plan filters"
      tabindex="-1"
      class="tw-hidden tb:tw-block tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-bg-dt-surface-elevated tw-rounded-t-3xl tw-shadow-elevation-sheet-top tw-z-[60] tw-h-4/5 tw-overflow-y-auto tw-pb-[var(--safe-area-bottom,0px)] tw-transform tw-transition-transform tw-duration-300 tw-ease-out"
      [ngClass]="showMobileFilter() ? 'tw-translate-y-0' : 'tw-translate-y-full'"
    >
      <!-- down arrow button -->
      <div class="tw-flex tw-items-center tw-justify-center tw-p-2 tw-w-full">
        <button
          class="tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-rounded-full"
          (click)="toggleMobileFilter()"
        >
          <icon [name]="'down-arrow-primary'" [size]="6" [disableArrowOverride]="true"></icon>
        </button>
      </div>

      <!-- Filter content -->
      <div class="tw-p-4">
        <app-plans-filter
          [filterConfig]="filterConfig()"
          [isMobile]="true"
          (filterChange)="onFilterChange($event)"
        ></app-plans-filter>
      </div>
    </div>
  }

  <!--  plans-->
  <div class="tw-flex tw-flex-col tw-gap-4 tw-w-full tw-flex-1 tb:tw-order-3">
    <div class="tw-flex tw-flex-col tw-w-full tw-gap-4">
      <!--      title-->
      <div class="tw-flex tw-gap-2 tw-w-full tw-justify-between">
        <div class="tw-flex tw-flex-col tw-text-color-text-default tw-gap-1">
          <span class="tw-font-semibold tw-text-[18px] tw-leading-[135%] tw-tracking-[0.25%]"
            >Choose a bundle that fits your needs</span
          >
          <span class="tw-text-[13px] tw-leading-[125%] tw-tracking-normal"
            >Each bundle includes specific plugins and features tailored for your region.</span
          >
        </div>
        <!--        filter toggle button (desktop -> dropdown panel, mobile -> bottom sheet) -->
        <div
          #filterWrapper
          class="tw-relative"
          appClickOutside
          appClickOutsideFocusOut
          (clickOutside)="onFilterClickOutside($event)"
        >
          <div
            #filterToggleButton
            class="tw-flex tw-items-center tw-justify-center tw-p-4 tw-h-fit tw-rounded-2xl tw-shadow-elevation-control border-gradient-subtle tw-cursor-pointer"
            [ngClass]="{ 'tw-bg-dt-surface-elevated': showMobileFilter() || desktopFilterOpen() }"
            role="button"
            tabindex="0"
            aria-haspopup="dialog"
            [attr.aria-expanded]="showMobileFilter() || desktopFilterOpen()"
            [attr.aria-controls]="
              showMobileFilter() ? 'plans-mobile-filter-panel' : 'plans-desktop-filter-panel'
            "
            (click)="toggleFilter()"
            (keydown.enter)="toggleFilter()"
            (keydown.space)="toggleFilter(); $event.preventDefault()"
          >
            <icon [name]="'bundle-funnel'" [size]="6"></icon>
          </div>

          <!-- Desktop dropdown filter panel -->
          @if (desktopFilterOpen()) {
            <div
              appGlossScroll
              #desktopFilterPanel
              id="plans-desktop-filter-panel"
              role="dialog"
              aria-label="Plan filters"
              tabindex="-1"
              class="tb:tw-hidden tw-absolute tw-top-full tw-right-0 tw-mt-2 tw-w-80 tw-max-h-[70vh] tw-overflow-y-auto tw-rounded-2xl tw-bg-dt-surface-elevated tw-shadow-elevation-card-hover tw-z-30 tw-p-4"
            >
              <app-plans-filter
                [filterConfig]="filterConfig()"
                [isMobile]="true"
                (filterChange)="onFilterChange($event)"
              ></app-plans-filter>
            </div>
          }
        </div>
      </div>

      <!--      switch button-->
      <div
        class="tw-flex tw-relative tw-w-fit tw-justify-center tw-items-center tw-p-1 tw-rounded-2xl tw-bg-dt-surface-page sm:tw-w-full"
      >
        <!-- Animated background slider -->
        <div
          class="tw-absolute tw-top-1 tw-bottom-1 tw-rounded-2xl tw-bg-color-surface-elevated border-gradient-neuomorphic tw-transition-all tw-duration-300 tw-ease-in-out"
          [ngStyle]="{
            left: selectedBillingCycle() === 'annual' ? '4px' : 'calc(60% + 4px)',
            right: selectedBillingCycle() === 'annual' ? 'auto' : '4px',
            width: selectedBillingCycle() === 'annual' ? 'calc(60% - 8px)' : 'calc(40% - 8px)',
          }"
        ></div>

        <!--       annual-->
        <div
          class="tw-relative tw-z-10 tw-flex tw-justify-center tw-items-center tw-gap-2 tw-px-6 tw-py-2 tw-rounded-2xl tw-cursor-pointer tw-transition-colors tw-duration-300"
          style="flex: 1.5"
          (click)="selectBillingCycle('annual')"
        >
          <span
            class="tw-font-medium tw-text-[14px] tw-leading-[125%] tw-tracking-[0.4%] tw-transition-colors tw-duration-300"
            [ngClass]="
              selectedBillingCycle() === 'annual'
                ? 'tw-text-dt-text-headings'
                : 'tw-text-dt-text-secondary'
            "
            >Annual</span
          >
          <div class="tw-rounded-[60px] tw-bg-dt-surface-in tw-py-1.5 tw-px-3">
            <span
              class="tw-text-dt-text-in-primary tw-font-medium tw-leading-[125%] tw-tracking-[0.4%] tw-whitespace-nowrap"
              >Save {{ planOptions.premiumAnnual.youSave }}</span
            >
          </div>
        </div>
        <!--       monthly-->
        <div
          class="tw-relative tw-z-10 tw-flex tw-h-full tw-justify-center tw-items-center tw-gap-2 tw-px-6 tw-py-2 tw-rounded-2xl tw-cursor-pointer tw-transition-colors tw-duration-300"
          style="flex: 1"
          (click)="selectBillingCycle('monthly')"
        >
          <span
            class="tw-text-[14px] tw-leading-[125%] tw-tracking-[1.25%] tw-transition-colors tw-duration-300"
            [ngClass]="
              selectedBillingCycle() === 'monthly'
                ? 'tw-font-medium tw-text-dt-text-headings'
                : 'tw-text-dt-text-secondary'
            "
            >Monthly</span
          >
        </div>
      </div>
    </div>

    <!-- Plan Cards -->
    <div class="tw-flex tw-flex-col tw-w-full tw-relative tw-overflow-hidden tw-py-4 tw-px-2">
      <div
        class="tw-flex tw-gap-6 tw-transition-transform tw-duration-300 tw-ease-in-out"
        [ngStyle]="{
          transform:
            selectedBillingCycle() === 'annual'
              ? 'translateX(0)'
              : 'translateX(calc(-100% - 24px))',
        }"
      >
        <!-- Annual Plan -->
        <div class="tw-w-full tw-flex-shrink-0">
          <ng-container
            *ngTemplateOutlet="
              planCard;
              context: {
                plan: planOptions.premiumAnnual,
                showBadge: true,
                onDetailsClick: openAnnualPlanDialog.bind(this),
              }
            "
          >
          </ng-container>
        </div>

        <!-- Monthly Plan -->
        <div class="tw-w-full tw-flex-shrink-0">
          <ng-container
            *ngTemplateOutlet="
              planCard;
              context: {
                plan: planOptions.premiumMonthly,
                showBadge: false,
                onDetailsClick: openMonthlyPlanDialog.bind(this),
              }
            "
          >
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <!--  your bundle-->
  <div
    class="tw-flex tw-flex-1 tw-flex-col tw-items-center tw-gap-3 tw-h-full tw-bg-dt-surface-card tw-p-4 tw-rounded-3xl tw-shadow-elevation-card-hover tb:tw-w-full tw-w-[1/5] tw-min-w-[312px] tb:tw-order-1"
  >
    <div class="tw-w-full">
      <span
        class="tw-font-semibold tw-text-[14px] tw-text-dt-text-secondary tw-leading-[125%] tw-tracking-[1.25%] tw-uppercase"
        >Your Bundle</span
      >
    </div>

    <!--    selected bundle-->
    @if (isPremiumMember()) {
      <!-- User has a premium subscription -->
      <div
        class="tw-flex tw-flex-col tw-gap-6 tw-rounded-2xl tw-shadow-elevation-input tw-px-3 tw-pb-3 tw-pt-6 tw-w-full tw-cursor-pointer tw-bg-dt-surface-page"
        (click)="openYourBundleDialog()"
      >
        <div class="tw-flex tw-gap-6">
          <!-- Icon -->
          <div class="tw-flex tw-gap-3">
            <div
              class="tw-flex tw-items-center tw-justify-center tw-p-3 tw-rounded-xl tw-bg-dt-surface-today-secondary tw-w-[48px] tw-h-[48px] tw-aspect-square"
            >
              <icon [name]="'bank-primary'" [size]="6"></icon>
            </div>
          </div>
          <!-- Payment/Cycle -->
          <div class="tw-flex tw-flex-col">
            <span
              class="tw-font-bold tw-text-[16px] tw-tracking-normal tw-leading-[125%] tw-text-dt-text-headings"
              >{{ getSelectedMarketLabel() }}</span
            >
            <div class="tw-flex tw-w-full tw-items-center tw-gap-2">
              <span
                class="tw-font-medium tw-text-[20px] tw-tracking-[0.25%] tw-leading-[125%] tw-text-dt-text-headings tw-font-D-DIN-PRO"
                >{{ userStoreService.subscription.activeSubscription()?.currency?.toUpperCase() }}
                {{ userStoreService.subscription.activeSubscription()?.fee }}</span
              >
              <span
                class="tw-font-medium tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-secondary"
                >/{{ userStoreService.subscription.activeSubscription()?.paymentCycle }}</span
              >
            </div>
          </div>
        </div>

        <!--        <ng-container *ngTemplateOutlet="planDesc"></ng-container>-->
        <div class="tw-flex tw-flex-col tw-w-full tw-bg-dt-surface-card tw-rounded-xl">
          <div
            class="tw-flex tw-flex-col tw-w-full tw-p-4 tw-gap-4 tw-justify-center tw-items-center"
          >
            <!--          subscription status badge (trial or active) -->
            <div
              class="tw-flex tw-w-fit tw-py-1 tw-px-3 tw-items-center tw-justify-center tw-rounded-[60px] tw-border tw-gap-1"
              [ngClass]="{
                'tw-border-dt-border-in tw-bg-dt-surface-in': isInTrialPeriod(),
                'tw-border-dt-border-today-primary tw-bg-dt-surface-today-tertiary':
                  !isInTrialPeriod(),
              }"
            >
              @if (!isInTrialPeriod()) {
                <icon
                  [name]="'star-bundle-activeSub'"
                  [size]="4"
                  [currentColor]="'dt-text-action'"
                ></icon>
              }
              <span
                class="tw-font-medium tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%]"
                [ngClass]="{
                  'tw-text-dt-text-in-primary': isInTrialPeriod(),
                  'tw-text-dt-text-action': !isInTrialPeriod(),
                }"
                >{{
                  isInTrialPeriod()
                    ? "Free Trial Active"
                    : getSelectedMarketLabel() + " Bundle (Active)"
                }}</span
              >
            </div>

            @if (isInTrialPeriod()) {
              <div class="tw-flex tw-gap-2 tw-w-full">
                <icon [size]="8" [name]="'bell-primary'"></icon>
                <div class="tw-flex tw-flex-col tw-gap-1">
                  <span
                    class="tw-font-medium tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-headings"
                    >Trial ends in
                    <span class="tw-text-dt-text-action tw-font-bold">{{
                      trialRemainingDays() ?? 0
                    }}</span>
                    days</span
                  >
                  <span
                    class="tw-font-medium tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-secondary tw-w-fit"
                    >We'll notify you 3 days before billing.</span
                  >
                </div>
              </div>
            }

            <div class="tw-flex tw-gap-2 tw-w-full">
              <icon [size]="8" [name]="'calendar'" [currentColor]="'primary'"></icon>
              <div class="tw-flex tw-flex-col tw-gap-1">
                <span
                  class="tw-font-medium tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-headings"
                  >Next billing date</span
                >
                <span
                  class="tw-font-medium tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-secondary"
                  >{{ formattedBillingDate() }}</span
                >
              </div>
            </div>
          </div>

          <div
            class="tw-flex tw-justify-between tw-bg-color-surface-elevated tw-rounded-xl tw-items-center tw-p-4"
          >
            <span
              class="tw-font-medium tw-text-[16px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-secondary"
              >Know more details</span
            >
            <icon [size]="6" [name]="'right-arrow'" [currentColor]="'dt-text-secondary'"></icon>
          </div>
        </div>
      </div>
    } @else {
      <!-- User doesn't have a premium subscription -->
      <div
        class="tw-flex tw-gap-3 tw-justify-center tw-items-center tw-p-4 tw-rounded-2xl tw-shadow-elevation-card tw-w-full tw-min-h-32 tw-bg-dt-surface-page"
      >
        <div
          class="tw-flex tw-flex-col tw-gap-6 tw-w-full tw-h-full tw-items-center tw-justify-center"
        >
          <!--          round-->
          <div class="tw-flex tw-rounded-[76px] tw-p-8 tw-shadow-elevation-card">
            <icon [size]="8" [name]="'star-bundle'"></icon>
          </div>
          <!--          text-->
          <div
            class="tw-flex tw-flex-col tw-w-full tw-gap-3 tw-items-center tw-justify-center tw-font-medium tw-tracking-[0.4%] tw-leading-[125%]"
          >
            <span class="tw-text-dt-text-tertiary tw-text-center"
              >You haven't selected a bundle yet</span
            >
            <span class="tw-text-dt-text-tertiary tw-text-center"
              >Explore bundles and start your free trial.</span
            >
          </div>
        </div>
      </div>
    }

    <auto-credit-redemption-toggle class="tw-contents"></auto-credit-redemption-toggle>

    <ng-container
      *ngTemplateOutlet="
        actionButton;
        context: { label: 'explore plugins', onClick: navigateToPlugins.bind(this) }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        actionButton;
        context: { label: 'manage billing', onClick: navigateToSubscription.bind(this) }
      "
    ></ng-container>
  </div>
</div>

<ng-template #planDesc let-showViewDetails="showViewDetails" let-onDetailsClick="onDetailsClick">
  <div
    appGlossScroll
    class="tw-flex tw-flex-col tw-w-full tw-p-4 tw-bg-dt-surface-card tw-max-h-32 tw-overflow-y-auto tw-rounded-lg"
  >
    <div class="tw-flex tw-flex-col tw-gap-2 tw-w-full">
      <div class="tw-flex tw-gap-2">
        <icon [size]="4" [name]="'check-only'" [currentColor]="'primary'"></icon>
        <span
          class="tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-headings"
          >{{ "autoRetrieveBankData" | i18n }}</span
        >
      </div>
      <div class="tw-flex tw-gap-2">
        <icon [size]="4" [name]="'check-only'" [currentColor]="'primary'"></icon>
        <span
          class="tw-text-[14px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-headings"
          >{{ "fileStorage" | i18n }}</span
        >
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #planCard
  let-plan="plan"
  let-showBadge="showBadge"
  let-onDetailsClick="onDetailsClick"
>
  <div
    class="tw-flex tw-flex-col tw-w-full tw-gap-3 tw-p-4 sm:tw-p-2 tw-rounded-3xl tw-bg-color-surface-elevated tw-shadow-elevation-card"
    (click)="handlePlanCardClick(plan, $event, onDetailsClick)"
  >
    <div class="tw-flex tw-gap-4 tw-w-full tw-justify-between">
      <div class="tw-flex tw-gap-4 sm:tw-gap-2">
        <!-- Icon and Badge -->
        <div class="tw-flex tw-gap-3">
          <div
            class="tw-flex tw-items-center tw-justify-center tw-p-3 tw-rounded-xl tw-bg-dt-surface-today-secondary tw-w-[48px] tw-h-[48px] sm:tw-w-[40px] sm:tw-h-[40px] tw-aspect-square"
          >
            <icon [name]="'bank-primary'" [size]="6"></icon>
          </div>
        </div>
        <!--      payment/cycle-->
        <div class="tw-flex tw-flex-col tw-gap-1">
          <span
            class="tw-font-medium tw-text-[16px] sm:tw-text-[14px] tw-tracking-normal tw-leading-[125%] tw-text-dt-text-headings tw-whitespace-nowrap"
            >{{ getSelectedMarketLabel() }}</span
          >
          <div
            class="tw-flex tw-w-full tw-items-center tw-gap-2 tw-whitespace-nowrap"
            [ngClass]="{ 'tw-justify-center': isApple }"
          >
            <span
              class="tw-font-semibold tw-text-[24px] sm:tw-text-[20px] tw-tracking-normal tw-leading-[125%] tw-text-dt-text-headings tw-font-D-DIN-PRO"
              >{{ plan.feeAmount }}</span
            >
            <span
              class="tw-font-medium tw-text-[14px] sm:tw-text-[13px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-secondary"
              >{{ plan.paymentCycle }}</span
            >
          </div>
          <span
            class="tw-font-medium tw-text-[14px] sm:tw-text-[13px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-tertiary"
            >Billed {{ plan.label | i18n }}</span
          >
        </div>
      </div>
      @if (showBadge && plan.youSave) {
        <div class="badge-filled tw-h-fit">
          <span
            class="tw-font-medium tw-text-[14px] sm:tw-text-[13px] tw-tracking-[0.4%] tw-leading-[125%] tw-text-dt-text-in-primary tw-whitespace-nowrap"
            >Save {{ plan.youSave }}</span
          >
        </div>
      }
    </div>
    <div class="tw-flex">
      <ng-container
        *ngTemplateOutlet="
          planDesc;
          context: { showViewDetails: true, onDetailsClick: onDetailsClick }
        "
      ></ng-container>
    </div>
    <button
      class="tw-w-full tw-flex tw-rounded-[50px] tw-py-3.5 tw-h-[48px] tw-justify-center tw-items-center tw-transition-all tw-duration-200"
      [ngClass]="{
        'tw-bg-dt-surface-on-action hover:tw-scale-[1.01] active:tw-scale-[0.99] tw-cursor-pointer':
          !isCurrentBundle(plan),
        'tw-bg-dt-surface-disabled': isCurrentBundle(plan),
      }"
      [disabled]="isCurrentBundle(plan)"
      (click)="!isCurrentBundle(plan) && onDetailsClick($event)"
    >
      <span
        class="tw-font-bold tw-text-[16px] tw-tracking-normal tw-leading-[125%]"
        [ngClass]="{
          'tw-text-dt-text-on-action': !isCurrentBundle(plan),
          'tw-text-dt-text-disabled': isCurrentBundle(plan),
        }"
        >{{
          isCurrentBundle(plan) ? "Your Current Bundle" : "View Details & Start Free Trial"
        }}</span
      >
    </button>
  </div>
</ng-template>

<ng-template #actionButton let-label="label" let-onClick="onClick">
  <div class="tw-flex tw-w-full">
    <button
      class="tw-flex tw-w-full tw-pl-2 tw-pr-4 tw-py-4 tw-items-center tw-justify-between"
      (click)="onClick()"
    >
      <div class="tw-flex tw-gap-2 tw-items-center">
        <icon [size]="8" [name]="'plugins'" [currentColor]="'color-icon-secondary'"></icon>
        <span
          class="tw-font-medium tw-text-dt-text-secondary tw-text-[16px] tw-tracking-normal tw-leading-[125%]"
          >{{ label }}</span
        >
      </div>
      <icon [size]="6" [name]="'right-arrow'"></icon>
    </button>
  </div>
</ng-template>
